export type RuntimeEnv = {
  cmsUrl?: string;
  imgUrl?: string;
  apiUrl?: string;
  googleRecaptchaKey?: string;
  host?: string;
  optimumUrl?: string;
  mobilizeEthicalPage?: string;
  nuveiEnvironment?: string;
  nuveiCode?: string;
  nuveiKey?: string;
};

declare global {
  interface Window { __env?: RuntimeEnv; }
}

let cachedEnv: RuntimeEnv | null = null;

export const runtimeEnv: RuntimeEnv = new Proxy({} as RuntimeEnv, {
  get: (target, prop: string | symbol) => {
    if (!cachedEnv) {
      cachedEnv = (typeof window !== 'undefined' && (window as any).__env) ? (window as any).__env : {};
    }
    return (cachedEnv as any)[prop];
  }
});
